(() => {
  const hub = document.querySelector('[data-mystic-mobile-hub]');
  const backdrop = document.querySelector('[data-mystic-mobile-hub-backdrop]');

  if (!hub || !backdrop) {
    return;
  }

  const closeButtons = hub.querySelectorAll('[data-mystic-mobile-hub-close]');
  const panel = hub.querySelector('.mystic-mobile-hub__panel');
  const authControls = hub.querySelectorAll('[data-mystic-hub-auth-control]');
  let lastFocusedElement = null;
  let closeTimer = null;
  let resizeTimer = null;

  const getTriggers = () => document.querySelectorAll('[data-mystic-hub-trigger]');

  const updateTriggers = (isOpen) => {
    getTriggers().forEach((trigger) => {
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      trigger.classList.toggle('is-hub-open', isOpen);
    });
  };

  const setAuthControlsEnabled = (enabled) => {
    authControls.forEach((control) => {
      control.disabled = !enabled;

      if (enabled) {
        control.removeAttribute('tabindex');
      } else {
        control.setAttribute('tabindex', '-1');
      }

      if ('readOnly' in control) {
        control.readOnly = !enabled;
      }
    });
  };

  const finishClose = (restoreFocus = true) => {
    hub.hidden = true;
    backdrop.hidden = true;
    setAuthControlsEnabled(false);

    if (
      restoreFocus &&
      lastFocusedElement &&
      lastFocusedElement.isConnected &&
      !hub.contains(lastFocusedElement) &&
      typeof lastFocusedElement.focus === 'function'
    ) {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  const openHub = () => {
    window.clearTimeout(closeTimer);
    document.dispatchEvent(new CustomEvent('mystic:mobile-hub:open'));
    lastFocusedElement = document.activeElement;
    hub.hidden = false;
    backdrop.hidden = false;
    hub.setAttribute('aria-hidden', 'false');
    updateTriggers(true);
    setAuthControlsEnabled(true);
    document.body.classList.add('mystic-mobile-hub-open');

    requestAnimationFrame(() => {
      hub.classList.add('is-open');
      backdrop.classList.add('is-open');
    });
  };

  const closeHub = ({ instant = false, restoreFocus = true } = {}) => {
    window.clearTimeout(closeTimer);
    hub.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    hub.setAttribute('aria-hidden', 'true');
    updateTriggers(false);
    setAuthControlsEnabled(false);
    document.body.classList.remove('mystic-mobile-hub-open');

    if (instant) {
      finishClose(false);
      return;
    }

    closeTimer = window.setTimeout(() => finishClose(restoreFocus), 240);
  };

  const resetHubForViewportChange = () => {
    if (hub.hidden && !hub.classList.contains('is-open')) {
      return;
    }

    closeHub({ instant: true, restoreFocus: false });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mystic-hub-trigger]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    if (hub.classList.contains('is-open')) {
      closeHub();
      return;
    }

    openHub();
  });

  backdrop.addEventListener('click', closeHub);
  hub.addEventListener('click', (event) => {
    if (!panel || panel.contains(event.target)) {
      return;
    }

    closeHub();
  });
  closeButtons.forEach((button) => button.addEventListener('click', closeHub));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && hub.classList.contains('is-open')) {
      closeHub();
    }
  });

  document.addEventListener('mystic:mobile-search-menu:open', () => {
    if (hub.classList.contains('is-open')) {
      closeHub({ instant: true, restoreFocus: false });
    }
  });

  window.addEventListener(
    'resize',
    () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(resetHubForViewportChange, 80);
    },
    { passive: true }
  );

  window.addEventListener('orientationchange', resetHubForViewportChange, { passive: true });
})();
